export default __webpack_public_path__ + "static/media/tms-truffle-ex.20f643ae.webp";